import {Link, useMatch, useResolvedPath} from "react-router-dom";
import "./navbar.css";

export default function Sidebar(){
  if(window.location.pathname === "/boxtv"){
    return null;
  }
  return (
    <aside className={"none-mobile-tile"}>
      <CustomLink to="/">
        <h4>Dashboard</h4>
      </CustomLink>
      <CustomLink to="/news">
        <h4 style={{color: window.location.pathname === "/news" ? "var(--accent)" : undefined}}>Neuigkeiten</h4>
      </CustomLink>
      <CustomLink to="/schedule">
        <h4 style={{color: window.location.pathname === "/schedule" ? "var(--accent)" : undefined}}>Kursplanung</h4>
      </CustomLink>
      <CustomLink to="/planning">
        <h4 style={{color: window.location.pathname === "/planning" ? "var(--accent)" : undefined}}>Programmplanung</h4>
      </CustomLink>
      <CustomLink to="/users">
        <h4 style={{color: window.location.pathname === "/users" ? "var(--accent)" : undefined}}>Mitglieder</h4>
      </CustomLink>
      <CustomLink to="/settings">
        <h4 style={{color: window.location.pathname === "/settings" ? "var(--accent)" : undefined}}>Einstellungen</h4>
      </CustomLink>
      <CustomLink to="/products">
        <h4 style={{color: window.location.pathname === "/products" ? "var(--accent)" : undefined}}>Produkte</h4>
      </CustomLink>
    </aside>
  );
}

export function CustomLink({to, children, ...props}){
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({path: resolvedPath.pathname, end: true});
  // sodass nur exacter path gematched wird und nicht teil daovn
  return (
    <Link to={to} {...props}>
      {children}
    </Link>

  );
}